import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MyTasksPage from './MyTasksPage';

export default function TaskDetailRoute() {
  const navigate = useNavigate();
  const { taskId } = useParams();

  const initialTaskId = useMemo(() => (taskId ? taskId : null), [taskId]);

  return (
    <MyTasksPage
      initialTaskId={initialTaskId}
      onCloseTask={() => navigate('/tasks')}
    />
  );
}
